module.exports = __webpack_public_path__ + "assets/img/router_before_router_leave.f17260d6.jpg";